// Each entry here maps 1:1 to a box in the Taxonomy Manager screen.
// `type` is the value sent to the backend (matches your global-key-values "type" field).
// Data is now fetched from the API via getTaxonomyByType(type) instead of being static.

export const TAXONOMY_SECTIONS = [
  {
    type: "GENRES",
    title: "Genres",
  },
  {
    type: "BADGE",
    title: "Badges",
  },
  {
    type: "CONTENT_WARNING",
    title: "Content Warnings",
  },
  {
    type: "TRAILER_TYPE",
    title: "Trailer Type",
  },
  {
    type: "LANGUAGE",
    title: "Languages",
  },
  {
    type: "CONTENT_RATING",
    title: "Content Ratings",
  },
   {
    type: "SERIES_FORMAT",
    title: "Series Format",
  },
];